export default __webpack_public_path__ + "static/media/sort-asc.f3f6ac4e.svg";